export enum SyncProcessLogSubjectTypeEnum {
    General = 0,
    Visit = 1,
    Concept = 2,
    Period = 3,
    Contract = 4,
}